import { mapObjIndexed } from 'ramda'

export default function combineReducers(reducers) {
	function getUndefinedStateErrorMessage(key, action) {
		let actionType = action && action.type
		let actionName = actionType && `"${actionType.toString()}"` || 'an action'
		return (
			`Reducer "${key}" returned undefined handling ${actionName}. ` +
			`To ignore an action, you must explicitly return the previous state.`
		)
	}
	return function combination(state = {}, action) {
		let finalState = Object.assign({}, state)
		let hasChanged = false
		mapObjIndexed((reducer, key) => {
			let previousStateForKey = state[key]
			let nextStateForKey = reducer(previousStateForKey, action, finalState)
			if (nextStateForKey === undefined) {
				let errorMessage = getUndefinedStateErrorMessage(key, action)
				throw new Error(errorMessage)
			}
			if (nextStateForKey !== previousStateForKey) {
				finalState[key] = nextStateForKey
				hasChanged = true
			}
		}, reducers)
		return hasChanged ? finalState : state
	}
}



// WEBPACK FOOTER //
// ./src/utils/redux/combineReducers.js